var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Copy from './copy.js';
const StyledAside = styled.aside.withConfig({ displayName: "brc-StyledAside", componentId: "brc-v42nfs" }) `
  position: relative;
  padding: 0 1em;
  margin: 0;

  &::before {
    content: '';
    height: 100%;
    position: absolute;
    left: 0;
    width: 4px;
    border: solid ${({ theme, color = 'flounderYellow200' }) => theme[color]} 2px;
    background: ${({ theme, color = 'flounderYellow200' }) => theme[color]};
    border-radius: 2px;
  }
`;
const Title = styled.h3.withConfig({ displayName: "brc-Title", componentId: "brc-11adyp3" }) `
  color: ${({ theme }) => theme.neutral500};
  font-size: 12px;
  font-weight: bold;
  line-height: 18px;
`;
const Text = styled(Copy).attrs(() => ({ size: 'sm' })).withConfig({ displayName: "brc-Text", componentId: "brc-173v3kp" }) `
  color: ${({ theme }) => theme.neutral500};
  font-style: italic;
`;
const BlockQuote = (_a) => {
    var { title, children, color } = _a, props = __rest(_a, ["title", "children", "color"]);
    return (_jsxs(StyledAside, Object.assign({}, { color }, { "data-testid": "aside" }, props, { children: [title && _jsx(Title, { children: title }), _jsx(Text, { children: children })] })));
};
export default BlockQuote;
//# sourceMappingURL=aside.js.map